var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "regular-delivery__title" }, [
      _vm._v("\n    Магазины\n  ")
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "regular-delivery__content" },
      [
        _c(
          "div",
          { staticClass: "regular-delivery__actions" },
          [
            _c(
              "q-btn",
              {
                attrs: { outline: "" },
                on: { click: _vm.toggleGroupByRegion }
              },
              [_vm._v("\n        " + _vm._s(_vm.buttonText) + "\n      ")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("Table", {
          attrs: {
            "table-id": "regularDeliveryTable",
            "table-config": _vm.tableConfig,
            "table-data": _vm.stores,
            "current-page": _vm.page,
            pages: _vm.computedPages,
            "group-by": _vm.groupBy
          },
          on: { "row-click": _vm.rowClickHandler, request: _vm.onRequestData }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }